let isOpen = false
let closeHandler: (() => void) | null = null

export function isSuggestionPopupOpen(): boolean {
  return isOpen
}

export function setSuggestionPopupOpen(v: boolean): void {
  isOpen = v
}

export function setCloseHandler(fn: () => void): void {
  closeHandler = fn
}

export function clearCloseHandler(): void {
  closeHandler = null
}

export function closeSuggestionPopup(): void {
  closeHandler?.()
}
